<script>
import options from './OpretHoldOverlay.options'
export default options
</script>

<template>
  <article class="kb-create-team" aria-live="polite">
    <section class="kb-tilmeld-hold-kvittering__hero">
      <div class="kb-tilmeld-hold-kvittering__hero__title-wrapper">
        <div class="kb-tilmeld-hold-kvittering__hero__hero-title-circle">
          <div class="kb-tilmeld-hold-kvittering__hero__hero-title-icon">
            <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.7998 12L8.6998 19.2L20.1998 0.799988" stroke="white" stroke-width="2.3"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <h2 class="kb-tilmeld-hold-kvittering__hero__title-wrapper__title">
          {{
            getLabel('title')
          }}
        </h2>
      </div>
      <div class="kb-tilmeld-hold-kvittering__breaker">
        <svg viewBox="0 0 81 11" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
        </svg>
      </div>
      <p class="kb-tilmeld-hold-kvittering__success-text">
        {{
              getLabel('text')
            }}
      </p>
    </section>
    <div class="kb-create-team__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-create-team__content-container kb-forms">

      <template v-if="showSpinner">
        <div class="kb-create-team__spinner-container">
          <div class="kb-spinner-container kb-spinner-container--visible">
            <div class="kb-spinner-container__spinner">
            </div>
          </div>
          <p>Vent venligst mens vi kontrollere om du har tidligere hold der kan genaktiveres.</p>
        </div>
      </template>

      <!-- multiple previous teams -->
      <template v-if="!showSpinner && previousTeams.length > 1">
        <div class="kb-forms__container">
          <fieldset class="kb-forms__fieldset">
            <legend class="kb-forms__legend">{{
            getLabel('reuseMotivationTitle')
          }}</legend>
            <template v-for="team, teamindex in previousTeams" :key="teamindex">
              <label><input
                  :data-order="(selectedPreviousTeam && selectedPreviousTeam === team.id ? 'first' : teamindex)"
                  class="FormChoice__Input--Radio" v-model="selectedPreviousTeam" type="radio" name="previousteams"
                  :value="team.id"> {{
            team.name }} </label>
            </template>
          </fieldset>
        </div>
        <div class="kb-create-team__button-wrapper">
          <button @click="handleReactivateTeam" @keydown.tab="tabTrap"
            :data-order="(previousTeams.length > 1 ? previousTeams : 'first')"
            class="kb-button kb-button--full-color-spot kb-create-team__kb-button--full-color-spot">{{
            getLabel('confirmButton')
          }}</button>
          <button @click="handleCreateTeam" data-order="last" @keydown.tab="tabTrap" class="kb-button">{{
            getLabel('cancelButton')
          }}</button>
        </div>
      </template>

      <!-- one single previous team -->
      <template v-else-if="!showSpinner && previousTeams.length === 1">
        <p>{{
            getLabel('reuseMotivationTitle')
          }}</p>
        <p>
          {{ previousTeams[0].name }}
        </p>
        <div class="kb-create-team__button-wrapper">
          <button @click="handleReactivateTeam" @keydown.tab="tabTrap" data-order="first"
            class="kb-button kb-button--full-color-spot kb-create-team__kb-button--full-color-spot">{{
            getLabel('confirmButton')
          }}</button>
          <button @click="handleCreateTeam" data-order="last" @keydown.tab="tabTrap" class="kb-button">{{
            getLabel('cancelButton')
          }}</button>
        </div>
      </template>

      <!-- no previous teams -->
      <template v-else-if="!showSpinner">
        <p>{{ getLabel('noPreviousTeamText') }}</p>
        <button @click="handleCreateTeam" data-order="last" @keydown.tab="tabTrap" class="kb-button">{{
            getLabel('cancelButton')
          }}</button>
      </template>
    </div>
  </article>
</template>
